export const MENU_ITEM_MAX_CHAR_LENGTH = 60;
